import { render, staticRenderFns } from "./documentable.vue?vue&type=template&id=f363e6e0&"
import script from "./documentable.vue?vue&type=script&lang=js&"
export * from "./documentable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports